import styled from 'styled-components';

import { Div } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import { Card } from 'opencare-crown';

export const InfoCardFooter = styled(Div)`
  border-top: 1px solid ${colors.nickel};
  text-align: center;
  padding: 20px 0 0 0;
`;

export const StyledCard = styled(Card)`
  display: flex;

  && {
    border: 1px solid ${colors.silver};
    border-radius: 5px;
    box-shadow: 0 2px 1px rgba(0, 0, 0, 0.05);
    margin: ${(props) => props.margin};
    transition: box-shadow 0.1s;
  }

  & > .ant-card-body {
    flex: 1 1 auto;
    padding: 15px;
  }
`;
